export enum GoalSetterStatus {
    Above = 'Above',
    Below = 'Below',
    Within = 'Within',
    None = 'None',
    WithinAbove = 'WithinAbove'
}
